<template>
  <div class="homap">
    <!-- 地图载体 -->
    <div id="container"></div>
    <el-button class="btn" type="primary" size="mini" @click="retreat()" plain>后撤</el-button>
    <el-button class="btnTow" size="mini" type="primary" @click="initMap()" plain>重置</el-button>
  </div>
</template>
<script>
let MapKey = "92bf1b30d5d094e6a625fd046e52f2db";
import remoteLoad from "@/components/map/lib/remoteLoad.js";
export default {
  naem: "GDenclosure",
  props: ["mapList"],
  data() {
    return {
      // 地图数据
      AMapUI: null,
      AMap: null,
      map: null,
      marker: "",
      // 电子围栏部分
      beginPoints: [], //点坐标
      beginMarks: [], //点标记
      clickListener: "", //绑定地图点击事件
      beginNum: 0, //绘制前点数
      polygonEditor: "",
      polyline: "", //线路存储
      lineArr: "", //渲染路线数据存储
    };
  },
  async created() {
    // 已载入高德地图API，则直接初始化地图
    // 载入高德地图和UI组件
    Promise.all([
      remoteLoad(`http://webapi.amap.com/maps?v=1.3&key=${MapKey}`),
      remoteLoad("http://webapi.amap.com/ui/1.0/main.js"),
    ]).then(() => {
      this.initMap();
    });
  },
  mounted() {},
  methods: {
    initMap() {
      let that = this;
      var mapCenter = JSON.parse(localStorage.getItem("tr_tr_user"));
      mapCenter = [mapCenter.longitude, mapCenter.latitude];
      // 加载PositionPicker，loadUI的路径参数为模块名中 'ui/' 之后的部分
      if (this.mapList.length != 0) {
        var mapdata = [this.mapList[0].lng, this.mapList[0].lat];
      } else {
        var mapdata = mapCenter;
      }
      let AMapUI = (this.AMapUI = window.AMapUI);
      let AMap = (this.AMap = window.AMap);
      let mapConfig = {
        esizeEnable: true,
        zoom: 13,
        center: mapdata,
      };
      let map = (this.map = new AMap.Map("container", mapConfig));
      // 启用工具条
      AMap.plugin(["AMap.ToolBar", "AMap.PolyEditor"], function () {
        map.addControl(
          new AMap.ToolBar({
            position: "RB",
          })
        );
      });
      this.init();
    },
    // 初始化
    init() {
      this.beginPoints = [];
      this.beginMarks = [];
      this.beginNum = 0;
      this.clickListener = AMap.event.addListener(
        this.map,
        "click",
        this.mapOnClick
      );
      if (this.mapList.length != 0) {
        // this.mapList.pop();
        this.mapList.forEach((item) => {
          item.lnglat = {
            lng: item.lng,
            lat: item.lat,
            M: item.lng,
            O: item.lat,
          };
          this.mapOnClick(item);
        });
      }
    },
    // 地图点击事件
    mapOnClick(e) {
      // document.getElementById("lnglat").value = e.lnglat.getLng() + ',' + e.lnglat.getLat()
      this.beginMarks.push(this.addMarker(e.lnglat));
      this.beginPoints.push(e.lnglat);
      this.beginNum++;
      // if (this.beginNum == 3) {
      //   //处理有了3个点以后，转化为多边形的逻辑
      //   AMap.event.removeListener(this.clickListener);
      //   var polygon = this.createPolygon(this.beginPoints);
      //   var polygonEditor = this.createEditor(polygon);
      //   this.polygonEditor = polygonEditor;
      //   this.clearMarks();
      //   //处理结束
      // }
      this.beginPolyline(this.beginPoints);
    },
    addMarker(lnglat) {
      var marker = new AMap.Marker({
        icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: lnglat,
      });
      marker.setMap(this.map);

      return marker;
    },
    // 后撤
    retreat() {
      this.beginPoints.pop();
      this.beginMarks[this.beginNum - 1].setMap(null);
      this.beginMarks.pop();
      this.beginNum--;
      this.beginPolyline(this.beginPoints);
    },
    //上面用到的几个函数
    //创建一个多边形对象
    createPolygon(arr) {
      var polygon = new AMap.Polygon({
        map: this.map,
        path: arr,
        strokeColor: "#0000ff",
        strokeOpacity: 1,
        strokeWeight: 3,
        fillColor: "#f5deb3",
        fillOpacity: 0.35,
      });
      return polygon;
    },
    //创建一个多边形对象的编辑类对象
    createEditor(polygon) {
      var polygonEditor = new AMap.PolyEditor(this.map, polygon);
      polygonEditor.open();
      AMap.event.addListener(polygonEditor, "end", this.polygonEnd);
      return polygonEditor;
    },
    polygonEndOff() {
      if (this.beginPoints.length >= 3) {
        this.polygonEditor.close();
      } else {
        this.$message({
          message: "点位不全,请继续选择",
          type: "warning",
        });
        this.$emit("selectFunc", 0);
      }
    },
    //编辑结束事件
    polygonEnd(res) {
      if (this.beginPoints.length != 0) {
        this.$emit("selectFunc", this.beginPoints);
      } else {
        this.$emit("selectFunc", "");
      }
    },
    //将多边形路径保存到html隐藏域里
    appendHideHtml(index, arr) {
      var strify = JSON.stringify(arr);
      var html =
        '<input type="hidden" id="index' +
        index +
        '" name="paths[]" value="' +
        strify +
        '">';
      $("body").append(html);
    },
    //清除前面的3个点标记
    clearMarks() {
      this.map.remove(this.beginMarks);
    },
    beginPolyline(data) {
      this.lineArr = data;
      let lineArrData = [this.lineArr[0]];
      this.lineArr = [...this.lineArr, ...lineArrData];
      // 移除之前的路线
      if (this.polyline) {
        this.map.remove(this.polyline);
        this.polyline = "";
      }
      if (this.beginNum >= 2) {
        // 创建线覆盖物
        var polyline = new AMap.Polyline({
          path: this.lineArr,
          isOutline: true,
          outlineColor: "#ffeeff",
          borderWeight: 3,
          strokeColor: "#3366FF",
          strokeOpacity: 1,
          strokeWeight: 6,
          // 折线样式还支持 'dashed'
          strokeStyle: "solid",
          // strokeStyle是dashed时有效
          strokeDasharray: [10, 5],
          lineJoin: "round",
          lineCap: "round",
          zIndex: 50,
        });
        this.polyline = polyline;
        this.map.add(polyline);
      }
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
html,
body,
#container {
  height: 100%;
  width: 100%;
}
.btn {
  position: absolute;
  top: 20px;
  left: 20px;
}
.btnTow {
  position: absolute;
  top: 20px;
  left: 70px;
}
</style>


// WEBPACK FOOTER //
// src/components/map/GDenclosure.vue